import { render, staticRenderFns } from "./ui-drag-li.vue?vue&type=template&id=456be906&scoped=true"
import script from "./ui-drag-li.vue?vue&type=script&lang=ts"
export * from "./ui-drag-li.vue?vue&type=script&lang=ts"
import style0 from "./ui-drag-li.vue?vue&type=style&index=0&id=456be906&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456be906",
  null
  
)

export default component.exports